<template>
<w-sliding-popup type="setting" width="500px" ref="slidingPopup" :title="titleName" @close="onClose">
  <el-form slot="content" ref="vendorInfoForm" :model="vendorInfo" label-position="top">
    <el-row>
      <el-form-item label="벤더" prop="objCompanyId" :rules="{ required: true, trigger: 'change', validator: this.validatorForVendor }">
        <w-vendor-combobox ref="vendorCombobox" :edit-row="editRow" :disabled="disabledObjCompanyIdField" @change="onObjCompanyChange"/>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item label="벤더 OID" prop="objCompanyOid" :rules="{ required: true, trigger: 'blur', validator: this.validatorForOid }">
        <el-input v-model="vendorInfo.objCompanyOid" placeholder="입력해 주세요."></el-input>
      </el-form-item>
    </el-row>
  </el-form>
  <el-row slot="footer" type="flex" justify="center">
    <el-button class="mr-r4" size="large" type="solid" @click="saveVendorData">저장</el-button>
    <el-button size="large" @click="cancelVendorPopup">취소</el-button>
  </el-row>
</w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import { validateOid } from '@/utils/string';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import clone from 'lodash/clone';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import WVendorCombobox from '../component/VendorCombobox';

export default {
  name: 'WVendorOidPopup',
  components: {
    WVendorCombobox,
  },
  props: {
    editRow: Object,
    popupType: String,
    isAdd: Boolean,
  },
  data() {
    return {
      disabledObjCompanyIdField: false,
      selectedVendor: {},
      titleName: '',
      vendorInfo: {
        objCompanyOid: null,
        objCompanyId: null,
      },
    };
  },
  watch: {
    editRow: {
      immediate: true,
      handler(row) {
        this.vendorInfo = clone(row);
        if (this.popupType === 'ADD') {
          this.titleName = '벤더 OID 추가';
          this.disabledObjCompanyIdField = false;
        } else {
          this.titleName = '벤더 OID 수정';
          this.disabledObjCompanyIdField = true;
        }
      },
    },
    selectedVendor(to, from) {
      console.debug(to, from);
      if (to && (isEmpty(from) || from.objCompanyId !== to.objCompanyId)) {
        this.$refs.vendorInfoForm.validateField('objCompanyId');
      }
    },
  },
  methods: {
    /**
     * 팝업 open 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    open() {
      this.$refs.slidingPopup.open();
      if (this.$refs.vendorCombobox) {
        this.$refs.vendorCombobox.loadData();
      }
      this.$emit('open');
    },
    onClose() {
      this.$refs.vendorInfoForm.resetFields();
      this.$refs.vendorInfoForm.clearValidate();
      this.$refs.vendorCombobox.clear();
      this.selectedVendor = null;
    },
    /**
     * 팝업 close 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    close() {
      this.$refs.slidingPopup.close();
    },
    /**
     * [saveVendorData 벤더 OID 항목을 추가 또는 수정한다.]
     * @author yelim
     */
    saveVendorData() {
      const me = this;
      me.$refs.vendorInfoForm.validate((valid) => {
        if (valid) {
          if (me.popupType === 'ADD') {
            const saveParams = {
              objCompanyId: this.selectedVendor.objCompanyId,
              objCompanyOid: this.vendorInfo.objCompanyOid,
            };
            const target = '벤더 OID';
            const action = msgUtil.action.ADD;
            // 벤더 OID 항목을 추가한다.
            NetdeviceSettingAPI.insertVendorInfoList(saveParams).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                me.close();
                me.$emit('reload-data');
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          } else if (me.popupType === 'EDIT') {
            const saveParams = {
              objCompanyId: this.vendorInfo.objCompanyId,
              objCompanyOid: this.vendorInfo.objCompanyOid,
            };
            const target = '벤더 OID';
            const action = msgUtil.action.SAVE;
            // 벤더 OID 항목을 수정한다.
            NetdeviceSettingAPI.updateVendorInfoList(saveParams).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                me.close();
                me.$emit('reload-data');
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('정보를 올바르게 입력해주십시오.'));
        }
      });
    },
    /**
     * 취소 버튼 이벤트 핸들러
     * @author Ju
     */
    cancelVendorPopup() {
      this.close();
    },
    /**
     * [selectChange vendor combobox의 선택이 바뀌는 경우 값을 팝업의 vendorInfo에 저장한다.
     *  또한 selectedVendor에 선택한 항목에 대한 정보도 같이 저장한다.]
     * @author yelim
     */
    onObjCompanyChange(data) {
      this.selectedVendor = data;
    },
    /**
     * 벤더 필드 validator
     * @author Ju
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     */
    validatorForVendor(rule, value, callback) {
      if (isNil(this.selectedVendor) || isNil(this.selectedVendor.objCompanyId) || this.selectedVendor.objCompanyId === '') {
        callback(new Error('벤더를 선택해주십시오.'));
      } else if (this.popupType === 'ADD') {
        NetdeviceSettingAPI.isExistVendor(this.selectedVendor).then((response) => {
          if (response.data.success) {
            if (response.data.data) {
              callback(new Error('이미 OID가 설정된 벤더입니다.'));
            } else {
              callback();
            }
          } else {
            callback(new Error('벤더 OID 중복 여부를 확인하지 못하였습니다.'));
          }
        }).catch(() => {
          callback(new Error('벤더 OID 중복 여부를 확인하지 못하였습니다.'));
        });
      } else {
        callback();
      }
    },
    /**
     * oid 필드 validator
     * @author Ju
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validatorForOid(rule, value, callback) {
      if (isNil(value) || value === '') {
        callback(new Error('OID를 입력해주십시오.'));
      } else if (validateOid(value)) {
        callback();
      } else {
        callback(new Error('올바른 OID 형식을 입력해주십시오.'));
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/VendorModelOidSettings/popup/VendorOidPopup.vue